import axios from 'axios'
import qs from 'qs'

export const status = params => { return axios.get(`/staff/account/status`, { params: params }) }
export const listBanner = params => { return axios.get(`/staff/account/banner`, { params: params }) }
export const login = params => { return axios.post(`/staff/account/login`, params) }
export const logout = params => { return axios.post(`/staff/account/logout`, params) }
export const password = params => { return axios.post(`/staff/account/password`, params) }
export const getWechatAuth = params => { return axios.post(`/staff/account/wechat/auth`, params) }
export const bindWechat = params => { return axios.post(`/staff/account/wechat/bind?code=${params.code}`, params) }
export const unbindWechat = params => { return axios.post(`/staff/account/wechat/unbind`, params) }
export const getDevice = params => { return axios.get(`/staff/device/${params.id}`, { params: params }) }
export const startDevice = params => { return axios.post(`/staff/device/${params.id}/start`) }
export const getOrder = params => { return axios.get(`/staff/device/${params.id}`) }
export const getWxMpAuthUrl = params => { return axios.post(`/staff/wx/mp/auth/url`, params) }
export const wxMpAuthLogin = params => { return axios.post(`/staff/wx/mp/auth/login`, params) }
export const getWxMpBindUrl = params => { return axios.post(`/staff/wx/mp/bind/url`, params) }


// WEBPACK FOOTER //
// ./src/services/api/staff/index.js